import React from 'react';
import Icon from '../../../components/AppIcon';

const SyncStatusIndicator = ({ status, lastSync }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ar-EG', {
      hour: '2-digit',
      minute: '2-digit'
    })?.format(date);
  };

  const statusConfig = {
    connected: {
      icon: 'CheckCircle2',
      color: 'text-success',
      bgColor: 'bg-success/10',
      label: 'متصل'
    },
    syncing: {
      icon: 'RefreshCw',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      label: 'جاري المزامنة'
    },
    error: {
      icon: 'AlertCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      label: 'خطأ في الاتصال'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.connected;

  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-lg ${config?.bgColor}`}>
      <Icon 
        name={config?.icon} 
        size={16} 
        color={`var(--color-${status === 'connected' ? 'success' : status === 'syncing' ? 'warning' : 'error'})`}
        className={status === 'syncing' ? 'animate-spin' : ''}
      />
      <div className="text-right">
        <p className={`text-xs font-medium ${config?.color}`}>{config?.label}</p>
        {lastSync && (
          <p className="text-xs text-muted-foreground font-data">
            آخر مزامنة: {formatTime(lastSync)}
          </p>
        )}
      </div>
    </div>
  );
};

export default SyncStatusIndicator;